// UI strings for the Lyric Video Generator page (/lyrics-video-generator).
// Flat, per-language keys merged into the i18n `lyricsVideo` namespace via index.ts.

const lyricsVideoTranslations = {
  en: {
    seoTitle: "AI Lyric Video Generator - Create Synced Lyrics Videos | Solmi",
    seoDescription: "Upload a song or paste a music link, choose a background, and generate a synced lyric video with Solmi.",
    eyebrow: "AI lyric video generator",
    title: "Make a synced lyric video.",
    songHeading: "Song",
    tabLink: "Link",
    tabUpload: "Upload",
    tabLibrary: "My songs",
    linkPlaceholder: "Paste a Suno, YouTube, TikTok, or MP3 link",
    attach: "Attach",
    uploadAudio: "Upload audio",
    signInToSelect: "Sign in to select a song",
    loadingSongs: "Loading songs",
    aiSong: "AI song",
    noSongs: "No completed songs yet",
    trimTitle: "Trim clip",
    trimFullUsage: "Using the full track ({{duration}}).",
    trimRangeUsage: "Using {{duration}} from {{start}} to {{end}}.",
    trimLoading: "Loading trim controls for this track...",
    trimUnknown: "We couldn't read the duration, so the full track will be used.",
    trimStart: "Start",
    trimEnd: "End",
    trimStartTime: "Start time",
    trimEndTime: "End time",
    trimReset: "Reset 10s",
    trimFullTrack: "Full track",
    backgroundHeading: "Background",
    bgGradient: "Gradient",
    bgImage: "Image",
    bgCustomImage: "Custom image",
    bgUploadImage: "Upload image",
    gradientOcean: "Ocean",
    gradientDeep: "Deep",
    gradientAqua: "Aqua",
    presetWatercolor: "Watercolor",
    presetNeonRain: "Neon Rain",
    presetAurora: "Aurora",
    presetFloral: "Floral",
    settingsAspect: "Aspect",
    settingsText: "Text",
    settingsPosition: "Position",
    fontBold: "Bold",
    fontModern: "Modern",
    fontElegant: "Elegant",
    fontHandwritten: "Handwritten",
    positionCenter: "center",
    positionBottom: "bottom",
    generating: "Generating Lyrics Video",
    generateCta: "Generate Lyrics Video - {{cost}}",
    creditsCount: "{{count}} credits",
    creditsPerMin: "~30 credits/min",
    videosTitle: "Lyrics videos",
    videosEmpty: "No lyrics videos yet",
    videosSignIn: "Sign in to view your lyrics videos",
    videosPrevious: "Previous",
    videosNoPrevious: "No previous lyrics videos",
    cardDefaultTitle: "AI Lyric Video",
    cardStatusCompleted: "completed",
    cardView: "View",
    cardViewVideo: "View video",
    toastInvalidLink: "Paste a valid audio, Suno, YouTube, or TikTok link.",
    toastLinkAttached: "Song link attached",
    toastAudioUploaded: "Audio uploaded",
    toastAudioUploadFailed: "Audio upload failed",
    toastNoPlayableAudio: "This song does not have playable audio yet.",
    toastSongSelected: "Song selected",
    toastBackgroundUploaded: "Background uploaded",
    toastBackgroundUploadFailed: "Background upload failed",
    toastAttachFirst: "Attach a song first.",
    toastGenerated: "Lyric video generated",
    toastCreateFailed: "Could not create lyric video",
    untitledSong: "Untitled song",
  },
  es: {
    seoTitle: "Generador de Videos con Letras con IA - Crea Videos Sincronizados | Solmi",
    seoDescription: "Sube una canción o pega un enlace de música, elige un fondo y genera un video con letras sincronizadas con Solmi.",
    eyebrow: "Generador de videos con letras con AI",
    title: "Crea un video con letras sincronizadas.",
    songHeading: "Canción",
    tabLink: "Enlace",
    tabUpload: "Subir",
    tabLibrary: "Mis canciones",
    linkPlaceholder: "Pega un enlace de Suno, YouTube, TikTok o MP3",
    attach: "Adjuntar",
    uploadAudio: "Subir audio",
    signInToSelect: "Inicia sesión para seleccionar una canción",
    loadingSongs: "Cargando canciones",
    aiSong: "Canción AI",
    noSongs: "Aún no hay canciones completadas",
    trimTitle: "Recortar clip",
    trimFullUsage: "Se usará la pista completa ({{duration}}).",
    trimRangeUsage: "Se usarán {{duration}} de {{start}} a {{end}}.",
    trimLoading: "Cargando controles de recorte para esta pista...",
    trimUnknown: "No pudimos leer la duración, se usará la pista completa.",
    trimStart: "Inicio",
    trimEnd: "Fin",
    trimStartTime: "Tiempo de inicio",
    trimEndTime: "Tiempo de fin",
    trimReset: "Reset 10s",
    trimFullTrack: "Pista completa",
    backgroundHeading: "Fondo",
    bgGradient: "Degradado",
    bgImage: "Imagen",
    bgCustomImage: "Imagen personalizada",
    bgUploadImage: "Subir imagen",
    gradientOcean: "Océano",
    gradientDeep: "Profundo",
    gradientAqua: "Aqua",
    presetWatercolor: "Acuarela",
    presetNeonRain: "Neon Rain",
    presetAurora: "Aurora",
    presetFloral: "Floral",
    settingsAspect: "Proporción",
    settingsText: "Texto",
    settingsPosition: "Posición",
    fontBold: "Negrita",
    fontModern: "Moderno",
    fontElegant: "Elegante",
    fontHandwritten: "Manuscrita",
    positionCenter: "centro",
    positionBottom: "abajo",
    generating: "Generando video con letras",
    generateCta: "Generar video con letras - {{cost}}",
    creditsCount: "{{count}} créditos",
    creditsPerMin: "~30 créditos/min",
    videosTitle: "Videos con letras",
    videosEmpty: "Aún no hay videos con letras",
    videosSignIn: "Inicia sesión para ver tus videos con letras",
    videosPrevious: "Anterior",
    videosNoPrevious: "No hay videos con letras anteriores",
    cardDefaultTitle: "Video con letras AI",
    cardStatusCompleted: "completado",
    cardView: "Ver",
    cardViewVideo: "Ver video",
    toastInvalidLink: "Pega un enlace válido de audio, Suno, YouTube o TikTok.",
    toastLinkAttached: "Enlace de canción adjuntado",
    toastAudioUploaded: "Audio subido",
    toastAudioUploadFailed: "Error al subir el audio",
    toastNoPlayableAudio: "Esta canción aún no tiene audio reproducible.",
    toastSongSelected: "Canción seleccionada",
    toastBackgroundUploaded: "Fondo subido",
    toastBackgroundUploadFailed: "Error al subir el fondo",
    toastAttachFirst: "Adjunta una canción primero.",
    toastGenerated: "Video con letras generado",
    toastCreateFailed: "No se pudo crear el video con letras",
    untitledSong: "Canción sin título",
  },
  ja: {
    seoTitle: "AI 歌詞動画ジェネレーター - 同期歌詞ビデオを作成 | Solmi",
    seoDescription: "曲をアップロードするか音楽リンクを貼り付け、背景を選んで、Solmiで同期歌詞ビデオを生成しましょう。",
    eyebrow: "AI 歌詞動画ジェネレーター",
    title: "同期歌詞ビデオを作ろう。",
    songHeading: "曲",
    tabLink: "リンク",
    tabUpload: "アップロード",
    tabLibrary: "マイソング",
    linkPlaceholder: "Suno、YouTube、TikTok、またはMP3のリンクを貼り付け",
    attach: "添付",
    uploadAudio: "音声をアップロード",
    signInToSelect: "曲を選ぶにはログイン",
    loadingSongs: "曲を読み込み中",
    aiSong: "AI ソング",
    noSongs: "完成した曲はまだありません",
    trimTitle: "クリップをトリム",
    trimFullUsage: "トラック全体（{{duration}}）を使用中。",
    trimRangeUsage: "{{start}} から {{end}} の {{duration}} を使用中。",
    trimLoading: "このトラックのトリム操作を読み込み中...",
    trimUnknown: "長さを読み取れなかったため、トラック全体が使用されます。",
    trimStart: "開始",
    trimEnd: "終了",
    trimStartTime: "開始時間",
    trimEndTime: "終了時間",
    trimReset: "10s リセット",
    trimFullTrack: "フルトラック",
    backgroundHeading: "背景",
    bgGradient: "グラデーション",
    bgImage: "画像",
    bgCustomImage: "カスタム画像",
    bgUploadImage: "画像をアップロード",
    gradientOcean: "オーシャン",
    gradientDeep: "ディープ",
    gradientAqua: "アクア",
    presetWatercolor: "水彩",
    presetNeonRain: "ネオンレイン",
    presetAurora: "オーロラ",
    presetFloral: "フローラル",
    settingsAspect: "アスペクト",
    settingsText: "テキスト",
    settingsPosition: "位置",
    fontBold: "ボールド",
    fontModern: "モダン",
    fontElegant: "エレガント",
    fontHandwritten: "手書き",
    positionCenter: "中央",
    positionBottom: "下部",
    generating: "歌詞ビデオを生成中",
    generateCta: "歌詞ビデオを生成 - {{cost}}",
    creditsCount: "{{count}} クレジット",
    creditsPerMin: "~30 クレジット/分",
    videosTitle: "歌詞ビデオ",
    videosEmpty: "歌詞ビデオはまだありません",
    videosSignIn: "歌詞ビデオを表示するにはログイン",
    videosPrevious: "以前",
    videosNoPrevious: "以前の歌詞ビデオはありません",
    cardDefaultTitle: "AI 歌詞ビデオ",
    cardStatusCompleted: "完了",
    cardView: "表示",
    cardViewVideo: "ビデオを表示",
    toastInvalidLink: "有効な音声、Suno、YouTube、またはTikTokのリンクを貼り付けてください。",
    toastLinkAttached: "曲のリンクを添付しました",
    toastAudioUploaded: "音声をアップロードしました",
    toastAudioUploadFailed: "音声のアップロードに失敗しました",
    toastNoPlayableAudio: "この曲はまだ再生可能な音声がありません。",
    toastSongSelected: "曲を選択しました",
    toastBackgroundUploaded: "背景をアップロードしました",
    toastBackgroundUploadFailed: "背景のアップロードに失敗しました",
    toastAttachFirst: "最初に曲を添付してください。",
    toastGenerated: "歌詞ビデオを生成しました",
    toastCreateFailed: "歌詞ビデオを作成できませんでした",
    untitledSong: "無題の曲",
  },
  pt: {
    seoTitle: "Gerador de Vídeo de Letras com AI - Crie Vídeos Sincronizados | Solmi",
    seoDescription: "Envie uma música ou cole um link, escolha um plano de fundo e gere um vídeo de letra sincronizado com o Solmi.",
    eyebrow: "Gerador de vídeo de letras com AI",
    title: "Crie um vídeo de letra sincronizado.",
    songHeading: "Música",
    tabLink: "Link",
    tabUpload: "Upload",
    tabLibrary: "Minhas músicas",
    linkPlaceholder: "Cole um link do Suno, YouTube, TikTok ou MP3",
    attach: "Anexar",
    uploadAudio: "Enviar áudio",
    signInToSelect: "Entre para selecionar uma música",
    loadingSongs: "Carregando músicas",
    aiSong: "Música AI",
    noSongs: "Nenhuma música concluída ainda",
    trimTitle: "Cortar clipe",
    trimFullUsage: "Usando a faixa completa ({{duration}}).",
    trimRangeUsage: "Usando {{duration}} de {{start}} a {{end}}.",
    trimLoading: "Carregando controles de corte para esta faixa...",
    trimUnknown: "Não foi possível ler a duração, então a faixa completa será usada.",
    trimStart: "Início",
    trimEnd: "Fim",
    trimStartTime: "Hora de início",
    trimEndTime: "Hora de fim",
    trimReset: "Resetar 10s",
    trimFullTrack: "Faixa completa",
    backgroundHeading: "Plano de fundo",
    bgGradient: "Gradiente",
    bgImage: "Imagem",
    bgCustomImage: "Imagem personalizada",
    bgUploadImage: "Enviar imagem",
    gradientOcean: "Oceano",
    gradientDeep: "Profundo",
    gradientAqua: "Aqua",
    presetWatercolor: "Aquarela",
    presetNeonRain: "Chuva Neon",
    presetAurora: "Aurora",
    presetFloral: "Floral",
    settingsAspect: "Proporção",
    settingsText: "Texto",
    settingsPosition: "Posição",
    fontBold: "Negrito",
    fontModern: "Moderno",
    fontElegant: "Elegante",
    fontHandwritten: "Manuscrito",
    positionCenter: "centro",
    positionBottom: "baixo",
    generating: "Gerando Vídeo de Letra",
    generateCta: "Gerar Vídeo de Letra - {{cost}}",
    creditsCount: "{{count}} créditos",
    creditsPerMin: "~30 créditos/min",
    videosTitle: "Vídeos de letras",
    videosEmpty: "Nenhum vídeo de letra ainda",
    videosSignIn: "Entre para ver seus vídeos de letras",
    videosPrevious: "Anterior",
    videosNoPrevious: "Nenhum vídeo de letra anterior",
    cardDefaultTitle: "Vídeo de Letra AI",
    cardStatusCompleted: "concluído",
    cardView: "Ver",
    cardViewVideo: "Ver vídeo",
    toastInvalidLink: "Cole um link válido de áudio, Suno, YouTube ou TikTok.",
    toastLinkAttached: "Link da música anexado",
    toastAudioUploaded: "Áudio enviado",
    toastAudioUploadFailed: "Falha no envio do áudio",
    toastNoPlayableAudio: "Esta música ainda não tem áudio reproduzível.",
    toastSongSelected: "Música selecionada",
    toastBackgroundUploaded: "Plano de fundo enviado",
    toastBackgroundUploadFailed: "Falha no envio do plano de fundo",
    toastAttachFirst: "Anexe uma música primeiro.",
    toastGenerated: "Vídeo de letra gerado",
    toastCreateFailed: "Não foi possível criar o vídeo de letra",
    untitledSong: "Música sem título",
  },
  fr: {
    seoTitle: "Générateur de vidéos de paroles AI - Créez des vidéos synchronisées | Solmi",
    seoDescription: "Importez une chanson ou collez un lien musical, choisissez un arrière-plan et générez une vidéo de paroles synchronisée avec Solmi.",
    eyebrow: "Générateur de vidéos de paroles AI",
    title: "Créez une vidéo de paroles synchronisée.",
    songHeading: "Chanson",
    tabLink: "Lien",
    tabUpload: "Importer",
    tabLibrary: "Mes chansons",
    linkPlaceholder: "Collez un lien Suno, YouTube, TikTok ou MP3",
    attach: "Joindre",
    uploadAudio: "Importer l'audio",
    signInToSelect: "Connectez-vous pour sélectionner une chanson",
    loadingSongs: "Chargement des chansons",
    aiSong: "Chanson AI",
    noSongs: "Aucune chanson terminée pour l'instant",
    trimTitle: "Rogner le clip",
    trimFullUsage: "Utilisation de la piste entière ({{duration}}).",
    trimRangeUsage: "Utilisation de {{duration}} de {{start}} à {{end}}.",
    trimLoading: "Chargement des contrôles de rognage pour cette piste...",
    trimUnknown: "Impossible de lire la durée, la piste entière sera utilisée.",
    trimStart: "Début",
    trimEnd: "Fin",
    trimStartTime: "Heure de début",
    trimEndTime: "Heure de fin",
    trimReset: "Reset 10s",
    trimFullTrack: "Piste entière",
    backgroundHeading: "Arrière-plan",
    bgGradient: "Dégradé",
    bgImage: "Image",
    bgCustomImage: "Image personnalisée",
    bgUploadImage: "Importer une image",
    gradientOcean: "Océan",
    gradientDeep: "Profond",
    gradientAqua: "Aqua",
    presetWatercolor: "Aquarelle",
    presetNeonRain: "Neon Rain",
    presetAurora: "Aurora",
    presetFloral: "Floral",
    settingsAspect: "Format",
    settingsText: "Texte",
    settingsPosition: "Position",
    fontBold: "Gras",
    fontModern: "Moderne",
    fontElegant: "Élégant",
    fontHandwritten: "Manuscrit",
    positionCenter: "centre",
    positionBottom: "bas",
    generating: "Génération de la vidéo de paroles",
    generateCta: "Générer la vidéo de paroles - {{cost}}",
    creditsCount: "{{count}} crédits",
    creditsPerMin: "~30 crédits/min",
    videosTitle: "Vidéos de paroles",
    videosEmpty: "Aucune vidéo de paroles pour l'instant",
    videosSignIn: "Connectez-vous pour voir vos vidéos de paroles",
    videosPrevious: "Précédent",
    videosNoPrevious: "Aucune vidéo de paroles précédente",
    cardDefaultTitle: "Vidéo de paroles AI",
    cardStatusCompleted: "terminée",
    cardView: "Voir",
    cardViewVideo: "Voir la vidéo",
    toastInvalidLink: "Collez un lien audio, Suno, YouTube ou TikTok valide.",
    toastLinkAttached: "Lien de chanson joint",
    toastAudioUploaded: "Audio importé",
    toastAudioUploadFailed: "Échec de l'import audio",
    toastNoPlayableAudio: "Cette chanson n'a pas encore d'audio lisible.",
    toastSongSelected: "Chanson sélectionnée",
    toastBackgroundUploaded: "Arrière-plan importé",
    toastBackgroundUploadFailed: "Échec de l'import de l'arrière-plan",
    toastAttachFirst: "Joignez d'abord une chanson.",
    toastGenerated: "Vidéo de paroles générée",
    toastCreateFailed: "Impossible de créer la vidéo de paroles",
    untitledSong: "Chanson sans titre",
  },
  zh: {
    seoTitle: "AI 歌词视频生成器 - 制作同步歌词视频 | Solmi",
    seoDescription: "上传歌曲或粘贴音乐链接，选择背景，用 Solmi 生成同步歌词视频。",
    eyebrow: "AI 歌词视频生成器",
    title: "制作同步歌词视频。",
    songHeading: "歌曲",
    tabLink: "链接",
    tabUpload: "上传",
    tabLibrary: "我的歌曲",
    linkPlaceholder: "粘贴 Suno、YouTube、TikTok 或 MP3 链接",
    attach: "添加",
    uploadAudio: "上传音频",
    signInToSelect: "登录后选择歌曲",
    loadingSongs: "加载歌曲中",
    aiSong: "AI 歌曲",
    noSongs: "暂无已完成的歌曲",
    trimTitle: "剪辑片段",
    trimFullUsage: "使用完整曲目（{{duration}}）。",
    trimRangeUsage: "使用 {{start}} 至 {{end}} 共 {{duration}}。",
    trimLoading: "正在加载剪辑控件...",
    trimUnknown: "无法读取时长，将使用完整曲目。",
    trimStart: "开始",
    trimEnd: "结束",
    trimStartTime: "开始时间",
    trimEndTime: "结束时间",
    trimReset: "重置 10s",
    trimFullTrack: "完整曲目",
    backgroundHeading: "背景",
    bgGradient: "渐变",
    bgImage: "图片",
    bgCustomImage: "自定义图片",
    bgUploadImage: "上传图片",
    gradientOcean: "海洋",
    gradientDeep: "深邃",
    gradientAqua: "水蓝",
    presetWatercolor: "水彩",
    presetNeonRain: "霓虹雨",
    presetAurora: "极光",
    presetFloral: "花卉",
    settingsAspect: "比例",
    settingsText: "文字",
    settingsPosition: "位置",
    fontBold: "粗体",
    fontModern: "现代",
    fontElegant: "优雅",
    fontHandwritten: "手写",
    positionCenter: "居中",
    positionBottom: "底部",
    generating: "正在生成歌词视频",
    generateCta: "生成歌词视频 - {{cost}}",
    creditsCount: "{{count}} 积分",
    creditsPerMin: "~30 积分/分钟",
    videosTitle: "歌词视频",
    videosEmpty: "暂无歌词视频",
    videosSignIn: "登录后查看歌词视频",
    videosPrevious: "上一页",
    videosNoPrevious: "暂无历史歌词视频",
    cardDefaultTitle: "AI 歌词视频",
    cardStatusCompleted: "已完成",
    cardView: "查看",
    cardViewVideo: "查看视频",
    toastInvalidLink: "请粘贴有效的音频、Suno、YouTube 或 TikTok 链接。",
    toastLinkAttached: "歌曲链接已添加",
    toastAudioUploaded: "音频已上传",
    toastAudioUploadFailed: "音频上传失败",
    toastNoPlayableAudio: "该歌曲暂无可播放的音频。",
    toastSongSelected: "歌曲已选择",
    toastBackgroundUploaded: "背景已上传",
    toastBackgroundUploadFailed: "背景上传失败",
    toastAttachFirst: "请先添加歌曲。",
    toastGenerated: "歌词视频已生成",
    toastCreateFailed: "歌词视频创建失败",
    untitledSong: "未命名歌曲",
  },
  ko: {
    seoTitle: "AI 가사 동영상 생성기 - 싱크 가사 영상 만들기 | Solmi",
    seoDescription: "노래를 업로드하거나 음악 링크를 붙여넣고, 배경을 선택해 Solmi로 싱크 가사 영상을 만들어보세요.",
    eyebrow: "AI 가사 동영상 생성기",
    title: "싱크 가사 영상을 만들어보세요.",
    songHeading: "노래",
    tabLink: "링크",
    tabUpload: "업로드",
    tabLibrary: "내 노래",
    linkPlaceholder: "Suno, YouTube, TikTok 또는 MP3 링크 붙여넣기",
    attach: "첨부",
    uploadAudio: "오디오 업로드",
    signInToSelect: "노래를 선택하려면 로그인하세요",
    loadingSongs: "노래 불러오는 중",
    aiSong: "AI 노래",
    noSongs: "완성된 노래가 없습니다",
    trimTitle: "클립 자르기",
    trimFullUsage: "전체 트랙 사용 중 ({{duration}}).",
    trimRangeUsage: "{{start}}~{{end}} 구간 {{duration}} 사용 중.",
    trimLoading: "이 트랙의 자르기 컨트롤을 불러오는 중...",
    trimUnknown: "길이를 읽을 수 없어 전체 트랙이 사용됩니다.",
    trimStart: "시작",
    trimEnd: "끝",
    trimStartTime: "시작 시간",
    trimEndTime: "종료 시간",
    trimReset: "10s 초기화",
    trimFullTrack: "전체 트랙",
    backgroundHeading: "배경",
    bgGradient: "그라디언트",
    bgImage: "이미지",
    bgCustomImage: "커스텀 이미지",
    bgUploadImage: "이미지 업로드",
    gradientOcean: "오션",
    gradientDeep: "딥",
    gradientAqua: "아쿠아",
    presetWatercolor: "수채화",
    presetNeonRain: "네온 레인",
    presetAurora: "오로라",
    presetFloral: "플로럴",
    settingsAspect: "화면 비율",
    settingsText: "텍스트",
    settingsPosition: "위치",
    fontBold: "볼드",
    fontModern: "모던",
    fontElegant: "엘레강트",
    fontHandwritten: "손글씨",
    positionCenter: "가운데",
    positionBottom: "하단",
    generating: "가사 동영상 생성 중",
    generateCta: "가사 동영상 생성 - {{cost}}",
    creditsCount: "{{count}} 크레딧",
    creditsPerMin: "~30 크레딧/분",
    videosTitle: "가사 동영상",
    videosEmpty: "아직 가사 동영상이 없습니다",
    videosSignIn: "가사 동영상을 보려면 로그인하세요",
    videosPrevious: "이전",
    videosNoPrevious: "이전 가사 동영상 없음",
    cardDefaultTitle: "AI 가사 동영상",
    cardStatusCompleted: "완료됨",
    cardView: "보기",
    cardViewVideo: "영상 보기",
    toastInvalidLink: "유효한 오디오, Suno, YouTube 또는 TikTok 링크를 붙여넣으세요.",
    toastLinkAttached: "노래 링크 첨부됨",
    toastAudioUploaded: "오디오 업로드됨",
    toastAudioUploadFailed: "오디오 업로드 실패",
    toastNoPlayableAudio: "이 노래는 아직 재생 가능한 오디오가 없습니다.",
    toastSongSelected: "노래 선택됨",
    toastBackgroundUploaded: "배경 업로드됨",
    toastBackgroundUploadFailed: "배경 업로드 실패",
    toastAttachFirst: "먼저 노래를 첨부하세요.",
    toastGenerated: "가사 동영상 생성 완료",
    toastCreateFailed: "가사 동영상을 만들 수 없습니다",
    untitledSong: "제목 없는 곡",
  },
  id: {
    seoTitle: "Generator Video Lirik AI - Buat Video Lirik Tersinkron | Solmi",
    seoDescription: "Upload lagu atau tempel tautan musik, pilih latar belakang, dan buat video lirik tersinkron dengan Solmi.",
    eyebrow: "Generator video lirik AI",
    title: "Buat video lirik tersinkron.",
    songHeading: "Lagu",
    tabLink: "Tautan",
    tabUpload: "Upload",
    tabLibrary: "Lagu saya",
    linkPlaceholder: "Tempel tautan Suno, YouTube, TikTok, atau MP3",
    attach: "Lampirkan",
    uploadAudio: "Upload audio",
    signInToSelect: "Masuk untuk memilih lagu",
    loadingSongs: "Memuat lagu",
    aiSong: "Lagu AI",
    noSongs: "Belum ada lagu yang selesai",
    trimTitle: "Potong klip",
    trimFullUsage: "Menggunakan seluruh trek ({{duration}}).",
    trimRangeUsage: "Menggunakan {{duration}} dari {{start}} hingga {{end}}.",
    trimLoading: "Memuat kontrol potong untuk trek ini...",
    trimUnknown: "Durasi tidak dapat dibaca, sehingga seluruh trek akan digunakan.",
    trimStart: "Mulai",
    trimEnd: "Selesai",
    trimStartTime: "Waktu mulai",
    trimEndTime: "Waktu selesai",
    trimReset: "Reset 10s",
    trimFullTrack: "Trek penuh",
    backgroundHeading: "Latar belakang",
    bgGradient: "Gradien",
    bgImage: "Gambar",
    bgCustomImage: "Gambar kustom",
    bgUploadImage: "Upload gambar",
    gradientOcean: "Ocean",
    gradientDeep: "Deep",
    gradientAqua: "Aqua",
    presetWatercolor: "Watercolor",
    presetNeonRain: "Neon Rain",
    presetAurora: "Aurora",
    presetFloral: "Floral",
    settingsAspect: "Rasio",
    settingsText: "Teks",
    settingsPosition: "Posisi",
    fontBold: "Tebal",
    fontModern: "Modern",
    fontElegant: "Elegan",
    fontHandwritten: "Tulisan tangan",
    positionCenter: "tengah",
    positionBottom: "bawah",
    generating: "Membuat Video Lirik",
    generateCta: "Buat Video Lirik - {{cost}}",
    creditsCount: "{{count}} kredit",
    creditsPerMin: "~30 kredit/menit",
    videosTitle: "Video lirik",
    videosEmpty: "Belum ada video lirik",
    videosSignIn: "Masuk untuk melihat video lirik kamu",
    videosPrevious: "Sebelumnya",
    videosNoPrevious: "Tidak ada video lirik sebelumnya",
    cardDefaultTitle: "Video Lirik AI",
    cardStatusCompleted: "selesai",
    cardView: "Lihat",
    cardViewVideo: "Lihat video",
    toastInvalidLink: "Tempel tautan audio, Suno, YouTube, atau TikTok yang valid.",
    toastLinkAttached: "Tautan lagu dilampirkan",
    toastAudioUploaded: "Audio berhasil diupload",
    toastAudioUploadFailed: "Upload audio gagal",
    toastNoPlayableAudio: "Lagu ini belum memiliki audio yang dapat diputar.",
    toastSongSelected: "Lagu dipilih",
    toastBackgroundUploaded: "Latar belakang berhasil diupload",
    toastBackgroundUploadFailed: "Upload latar belakang gagal",
    toastAttachFirst: "Lampirkan lagu terlebih dahulu.",
    toastGenerated: "Video lirik berhasil dibuat",
    toastCreateFailed: "Gagal membuat video lirik",
    untitledSong: "Lagu tanpa judul",
  },
  it: {
    seoTitle: "Generatore di Video Testo AI - Crea Video con Testi Sincronizzati | Solmi",
    seoDescription: "Carica una canzone o incolla un link musicale, scegli uno sfondo e genera un video con testi sincronizzati con Solmi.",
    eyebrow: "Generatore AI di video testo",
    title: "Crea un video testo sincronizzato.",
    songHeading: "Canzone",
    tabLink: "Link",
    tabUpload: "Carica",
    tabLibrary: "Le mie canzoni",
    linkPlaceholder: "Incolla un link Suno, YouTube, TikTok o MP3",
    attach: "Allega",
    uploadAudio: "Carica audio",
    signInToSelect: "Accedi per selezionare una canzone",
    loadingSongs: "Caricamento canzoni",
    aiSong: "Canzone AI",
    noSongs: "Nessuna canzone completata",
    trimTitle: "Ritaglia clip",
    trimFullUsage: "Utilizzo della traccia intera ({{duration}}).",
    trimRangeUsage: "Utilizzo di {{duration}} da {{start}} a {{end}}.",
    trimLoading: "Caricamento controlli di taglio per questa traccia...",
    trimUnknown: "Non è stato possibile leggere la durata, verrà usata la traccia intera.",
    trimStart: "Inizio",
    trimEnd: "Fine",
    trimStartTime: "Ora di inizio",
    trimEndTime: "Ora di fine",
    trimReset: "Reset 10s",
    trimFullTrack: "Traccia intera",
    backgroundHeading: "Sfondo",
    bgGradient: "Gradiente",
    bgImage: "Immagine",
    bgCustomImage: "Immagine personalizzata",
    bgUploadImage: "Carica immagine",
    gradientOcean: "Oceano",
    gradientDeep: "Profondo",
    gradientAqua: "Acqua",
    presetWatercolor: "Acquerello",
    presetNeonRain: "Pioggia Neon",
    presetAurora: "Aurora",
    presetFloral: "Floreale",
    settingsAspect: "Formato",
    settingsText: "Testo",
    settingsPosition: "Posizione",
    fontBold: "Grassetto",
    fontModern: "Moderno",
    fontElegant: "Elegante",
    fontHandwritten: "Scritto a mano",
    positionCenter: "centro",
    positionBottom: "basso",
    generating: "Generazione video testo in corso",
    generateCta: "Genera video testo - {{cost}}",
    creditsCount: "{{count}} crediti",
    creditsPerMin: "~30 crediti/min",
    videosTitle: "Video testo",
    videosEmpty: "Nessun video testo ancora",
    videosSignIn: "Accedi per visualizzare i tuoi video testo",
    videosPrevious: "Precedenti",
    videosNoPrevious: "Nessun video testo precedente",
    cardDefaultTitle: "AI Lyric Video",
    cardStatusCompleted: "completato",
    cardView: "Visualizza",
    cardViewVideo: "Guarda il video",
    toastInvalidLink: "Incolla un link audio, Suno, YouTube o TikTok valido.",
    toastLinkAttached: "Link canzone allegato",
    toastAudioUploaded: "Audio caricato",
    toastAudioUploadFailed: "Caricamento audio non riuscito",
    toastNoPlayableAudio: "Questa canzone non ha ancora audio riproducibile.",
    toastSongSelected: "Canzone selezionata",
    toastBackgroundUploaded: "Sfondo caricato",
    toastBackgroundUploadFailed: "Caricamento sfondo non riuscito",
    toastAttachFirst: "Allega prima una canzone.",
    toastGenerated: "Video testo generato",
    toastCreateFailed: "Impossibile creare il video testo",
    untitledSong: "Brano senza titolo",
  },
  nl: {
    seoTitle: "AI Liedtekstvideo Generator - Maak gesynchroniseerde lyrische video's | Solmi",
    seoDescription: "Upload een nummer of plak een muzieklink, kies een achtergrond en genereer een gesynchroniseerde lyrische video met Solmi.",
    eyebrow: "AI liedtekstvideo generator",
    title: "Maak een gesynchroniseerde lyrische video.",
    songHeading: "Nummer",
    tabLink: "Link",
    tabUpload: "Uploaden",
    tabLibrary: "Mijn nummers",
    linkPlaceholder: "Plak een Suno, YouTube, TikTok of MP3 link",
    attach: "Toevoegen",
    uploadAudio: "Audio uploaden",
    signInToSelect: "Inloggen om een nummer te selecteren",
    loadingSongs: "Nummers laden",
    aiSong: "AI nummer",
    noSongs: "Nog geen voltooide nummers",
    trimTitle: "Clip bijsnijden",
    trimFullUsage: "Volledig nummer wordt gebruikt ({{duration}}).",
    trimRangeUsage: "{{duration}} gebruikt van {{start}} tot {{end}}.",
    trimLoading: "Bijsnijdopties voor dit nummer laden...",
    trimUnknown: "De duur kon niet worden gelezen, dus het volledige nummer wordt gebruikt.",
    trimStart: "Begin",
    trimEnd: "Einde",
    trimStartTime: "Begintijd",
    trimEndTime: "Eindtijd",
    trimReset: "Reset 10s",
    trimFullTrack: "Volledig nummer",
    backgroundHeading: "Achtergrond",
    bgGradient: "Verloop",
    bgImage: "Afbeelding",
    bgCustomImage: "Eigen afbeelding",
    bgUploadImage: "Afbeelding uploaden",
    gradientOcean: "Oceaan",
    gradientDeep: "Diep",
    gradientAqua: "Aqua",
    presetWatercolor: "Aquarel",
    presetNeonRain: "Neon Rain",
    presetAurora: "Aurora",
    presetFloral: "Bloemen",
    settingsAspect: "Verhouding",
    settingsText: "Tekst",
    settingsPosition: "Positie",
    fontBold: "Vet",
    fontModern: "Modern",
    fontElegant: "Elegant",
    fontHandwritten: "Handgeschreven",
    positionCenter: "midden",
    positionBottom: "onder",
    generating: "Liedtekstvideo genereren",
    generateCta: "Liedtekstvideo genereren - {{cost}}",
    creditsCount: "{{count}} credits",
    creditsPerMin: "~30 credits/min",
    videosTitle: "Liedtekstvideo's",
    videosEmpty: "Nog geen liedtekstvideo's",
    videosSignIn: "Inloggen om je liedtekstvideo's te bekijken",
    videosPrevious: "Vorige",
    videosNoPrevious: "Geen eerdere liedtekstvideo's",
    cardDefaultTitle: "AI Liedtekstvideo",
    cardStatusCompleted: "voltooid",
    cardView: "Bekijken",
    cardViewVideo: "Video bekijken",
    toastInvalidLink: "Plak een geldige audio-, Suno-, YouTube- of TikTok-link.",
    toastLinkAttached: "Nummerlink toegevoegd",
    toastAudioUploaded: "Audio geüpload",
    toastAudioUploadFailed: "Audio uploaden mislukt",
    toastNoPlayableAudio: "Dit nummer heeft nog geen afspeelbare audio.",
    toastSongSelected: "Nummer geselecteerd",
    toastBackgroundUploaded: "Achtergrond geüpload",
    toastBackgroundUploadFailed: "Achtergrond uploaden mislukt",
    toastAttachFirst: "Voeg eerst een nummer toe.",
    toastGenerated: "Liedtekstvideo gegenereerd",
    toastCreateFailed: "Liedtekstvideo kon niet worden gemaakt",
    untitledSong: "Naamloos nummer",
  },
  pl: {
    seoTitle: "Generator Lyric Video AI - Twórz Zsynchronizowane Wideo z Tekstem | Solmi",
    seoDescription: "Wgraj piosenkę lub wklej link do muzyki, wybierz tło i wygeneruj zsynchronizowane lyric video z Solmi.",
    eyebrow: "Generator lyric video AI",
    title: "Stwórz zsynchronizowane lyric video.",
    songHeading: "Utwór",
    tabLink: "Link",
    tabUpload: "Wgraj",
    tabLibrary: "Moje piosenki",
    linkPlaceholder: "Wklej link Suno, YouTube, TikTok lub MP3",
    attach: "Załącz",
    uploadAudio: "Wgraj audio",
    signInToSelect: "Zaloguj się, aby wybrać piosenkę",
    loadingSongs: "Ładowanie piosenek",
    aiSong: "Piosenka AI",
    noSongs: "Brak ukończonych piosenek",
    trimTitle: "Przytnij klip",
    trimFullUsage: "Używany jest pełny utwór ({{duration}}).",
    trimRangeUsage: "Używany jest fragment {{duration}} od {{start}} do {{end}}.",
    trimLoading: "Ładowanie kontrolek przycinania...",
    trimUnknown: "Nie udało się odczytać czasu trwania — zostanie użyty pełny utwór.",
    trimStart: "Początek",
    trimEnd: "Koniec",
    trimStartTime: "Czas początku",
    trimEndTime: "Czas końca",
    trimReset: "Resetuj 10s",
    trimFullTrack: "Pełny utwór",
    backgroundHeading: "Tło",
    bgGradient: "Gradient",
    bgImage: "Obraz",
    bgCustomImage: "Własny obraz",
    bgUploadImage: "Wgraj obraz",
    gradientOcean: "Ocean",
    gradientDeep: "Głębia",
    gradientAqua: "Aqua",
    presetWatercolor: "Akwarela",
    presetNeonRain: "Neon Rain",
    presetAurora: "Aurora",
    presetFloral: "Kwiatowy",
    settingsAspect: "Format",
    settingsText: "Tekst",
    settingsPosition: "Pozycja",
    fontBold: "Pogrubiony",
    fontModern: "Nowoczesny",
    fontElegant: "Elegancki",
    fontHandwritten: "Odręczny",
    positionCenter: "środek",
    positionBottom: "dół",
    generating: "Generowanie Lyric Video",
    generateCta: "Generuj Lyric Video – {{cost}}",
    creditsCount: "{{count}} kredytów",
    creditsPerMin: "~30 kredytów/min",
    videosTitle: "Lyric video",
    videosEmpty: "Brak lyric video",
    videosSignIn: "Zaloguj się, aby zobaczyć swoje lyric video",
    videosPrevious: "Poprzednie",
    videosNoPrevious: "Brak poprzednich lyric video",
    cardDefaultTitle: "Lyric Video AI",
    cardStatusCompleted: "ukończono",
    cardView: "Zobacz",
    cardViewVideo: "Obejrzyj wideo",
    toastInvalidLink: "Wklej prawidłowy link do audio, Suno, YouTube lub TikTok.",
    toastLinkAttached: "Link do piosenki załączony",
    toastAudioUploaded: "Audio wgrane",
    toastAudioUploadFailed: "Wgrywanie audio nie powiodło się",
    toastNoPlayableAudio: "Ta piosenka nie ma jeszcze dostępnego audio.",
    toastSongSelected: "Piosenka wybrana",
    toastBackgroundUploaded: "Tło wgrane",
    toastBackgroundUploadFailed: "Wgrywanie tła nie powiodło się",
    toastAttachFirst: "Najpierw załącz piosenkę.",
    toastGenerated: "Lyric video wygenerowane",
    toastCreateFailed: "Nie udało się utworzyć lyric video",
    untitledSong: "Utwór bez tytułu",
  },
  tr: {
    seoTitle: "AI Şarkı Sözü Video Oluşturucu - Senkronize Şarkı Sözü Videoları Oluşturun | Solmi",
    seoDescription: "Bir şarkı yükleyin veya müzik bağlantısı yapıştırın, arka plan seçin ve Solmi ile senkronize şarkı sözü videosu oluşturun.",
    eyebrow: "AI şarkı sözü video oluşturucu",
    title: "Senkronize şarkı sözü videosu oluşturun.",
    songHeading: "Şarkı",
    tabLink: "Bağlantı",
    tabUpload: "Yükle",
    tabLibrary: "Şarkılarım",
    linkPlaceholder: "Suno, YouTube, TikTok veya MP3 bağlantısı yapıştırın",
    attach: "Ekle",
    uploadAudio: "Ses yükle",
    signInToSelect: "Şarkı seçmek için giriş yapın",
    loadingSongs: "Şarkılar yükleniyor",
    aiSong: "AI şarkısı",
    noSongs: "Henüz tamamlanmış şarkı yok",
    trimTitle: "Klibi kırp",
    trimFullUsage: "Parçanın tamamı kullanılıyor ({{duration}}).",
    trimRangeUsage: "{{start}} ile {{end}} arasındaki {{duration}} kullanılıyor.",
    trimLoading: "Bu parça için kırpma kontrolleri yükleniyor...",
    trimUnknown: "Süre okunamadı, parçanın tamamı kullanılacak.",
    trimStart: "Başlangıç",
    trimEnd: "Bitiş",
    trimStartTime: "Başlangıç zamanı",
    trimEndTime: "Bitiş zamanı",
    trimReset: "10s sıfırla",
    trimFullTrack: "Parçanın tamamı",
    backgroundHeading: "Arka Plan",
    bgGradient: "Degrade",
    bgImage: "Görsel",
    bgCustomImage: "Özel görsel",
    bgUploadImage: "Görsel yükle",
    gradientOcean: "Okyanus",
    gradientDeep: "Derin",
    gradientAqua: "Aqua",
    presetWatercolor: "Suluboya",
    presetNeonRain: "Neon Yağmur",
    presetAurora: "Aurora",
    presetFloral: "Çiçekli",
    settingsAspect: "Oran",
    settingsText: "Metin",
    settingsPosition: "Konum",
    fontBold: "Kalın",
    fontModern: "Modern",
    fontElegant: "Zarif",
    fontHandwritten: "El yazısı",
    positionCenter: "orta",
    positionBottom: "alt",
    generating: "Şarkı Sözü Videosu Oluşturuluyor",
    generateCta: "Şarkı Sözü Videosu Oluştur - {{cost}}",
    creditsCount: "{{count}} kredi",
    creditsPerMin: "~30 kredi/dak",
    videosTitle: "Şarkı sözü videoları",
    videosEmpty: "Henüz şarkı sözü videosu yok",
    videosSignIn: "Şarkı sözü videolarınızı görmek için giriş yapın",
    videosPrevious: "Önceki",
    videosNoPrevious: "Önceki şarkı sözü videosu yok",
    cardDefaultTitle: "AI Şarkı Sözü Videosu",
    cardStatusCompleted: "tamamlandı",
    cardView: "Görüntüle",
    cardViewVideo: "Videoyu görüntüle",
    toastInvalidLink: "Geçerli bir ses, Suno, YouTube veya TikTok bağlantısı yapıştırın.",
    toastLinkAttached: "Şarkı bağlantısı eklendi",
    toastAudioUploaded: "Ses yüklendi",
    toastAudioUploadFailed: "Ses yükleme başarısız",
    toastNoPlayableAudio: "Bu şarkının henüz oynatılabilir sesi yok.",
    toastSongSelected: "Şarkı seçildi",
    toastBackgroundUploaded: "Arka plan yüklendi",
    toastBackgroundUploadFailed: "Arka plan yükleme başarısız",
    toastAttachFirst: "Önce bir şarkı ekleyin.",
    toastGenerated: "Şarkı sözü videosu oluşturuldu",
    toastCreateFailed: "Şarkı sözü videosu oluşturulamadı",
    untitledSong: "Adsız şarkı",
  },
  vi: {
    seoTitle: "Tạo Video Lời Bài Hát bằng AI - Đồng Bộ Lyrics | Solmi",
    seoDescription: "Tải bài hát lên hoặc dán link nhạc, chọn nền, và tạo video lời bài hát đồng bộ với Solmi.",
    eyebrow: "Tạo video lyrics bằng AI",
    title: "Tạo video lyrics đồng bộ.",
    songHeading: "Bài hát",
    tabLink: "Link",
    tabUpload: "Tải lên",
    tabLibrary: "Bài của tôi",
    linkPlaceholder: "Dán link Suno, YouTube, TikTok hoặc MP3",
    attach: "Đính kèm",
    uploadAudio: "Tải âm thanh lên",
    signInToSelect: "Đăng nhập để chọn bài hát",
    loadingSongs: "Đang tải bài hát",
    aiSong: "Bài hát AI",
    noSongs: "Chưa có bài hát nào hoàn thành",
    trimTitle: "Cắt đoạn",
    trimFullUsage: "Đang dùng toàn bộ track ({{duration}}).",
    trimRangeUsage: "Đang dùng {{duration}} từ {{start}} đến {{end}}.",
    trimLoading: "Đang tải công cụ cắt cho track này...",
    trimUnknown: "Không đọc được thời lượng, sẽ dùng toàn bộ track.",
    trimStart: "Bắt đầu",
    trimEnd: "Kết thúc",
    trimStartTime: "Thời điểm bắt đầu",
    trimEndTime: "Thời điểm kết thúc",
    trimReset: "Đặt lại 10s",
    trimFullTrack: "Toàn bộ track",
    backgroundHeading: "Nền",
    bgGradient: "Chuyển màu",
    bgImage: "Hình ảnh",
    bgCustomImage: "Ảnh tùy chỉnh",
    bgUploadImage: "Tải ảnh lên",
    gradientOcean: "Đại dương",
    gradientDeep: "Thẳm sâu",
    gradientAqua: "Aqua",
    presetWatercolor: "Màu nước",
    presetNeonRain: "Neon Rain",
    presetAurora: "Cực quang",
    presetFloral: "Hoa lá",
    settingsAspect: "Tỉ lệ",
    settingsText: "Chữ",
    settingsPosition: "Vị trí",
    fontBold: "Đậm",
    fontModern: "Hiện đại",
    fontElegant: "Thanh lịch",
    fontHandwritten: "Viết tay",
    positionCenter: "giữa",
    positionBottom: "dưới",
    generating: "Đang tạo Video Lyrics",
    generateCta: "Tạo Video Lyrics - {{cost}}",
    creditsCount: "{{count}} credits",
    creditsPerMin: "~30 credits/phút",
    videosTitle: "Video lyrics",
    videosEmpty: "Chưa có video lyrics nào",
    videosSignIn: "Đăng nhập để xem video lyrics của bạn",
    videosPrevious: "Trước đó",
    videosNoPrevious: "Không có video lyrics trước đó",
    cardDefaultTitle: "Video Lyrics AI",
    cardStatusCompleted: "hoàn thành",
    cardView: "Xem",
    cardViewVideo: "Xem video",
    toastInvalidLink: "Dán link âm thanh, Suno, YouTube hoặc TikTok hợp lệ.",
    toastLinkAttached: "Đã đính kèm link bài hát",
    toastAudioUploaded: "Đã tải âm thanh lên",
    toastAudioUploadFailed: "Tải âm thanh thất bại",
    toastNoPlayableAudio: "Bài hát này chưa có âm thanh để phát.",
    toastSongSelected: "Đã chọn bài hát",
    toastBackgroundUploaded: "Đã tải nền lên",
    toastBackgroundUploadFailed: "Tải nền thất bại",
    toastAttachFirst: "Hãy đính kèm bài hát trước.",
    toastGenerated: "Đã tạo video lyrics",
    toastCreateFailed: "Không thể tạo video lyrics",
    untitledSong: "Bài hát chưa đặt tên",
  },
  de: {
    seoTitle: "AI Lyric-Video-Generator – Synchronisierte Lyrics-Videos erstellen | Solmi",
    seoDescription: "Lade einen Song hoch oder füge einen Musik-Link ein, wähle einen Hintergrund und erstelle mit Solmi ein synchronisiertes Lyric-Video.",
    eyebrow: "AI Lyric-Video-Generator",
    title: "Erstelle ein synchronisiertes Lyric-Video.",
    songHeading: "Song",
    tabLink: "Link",
    tabUpload: "Hochladen",
    tabLibrary: "Meine Songs",
    linkPlaceholder: "Suno-, YouTube-, TikTok- oder MP3-Link einfügen",
    attach: "Anhängen",
    uploadAudio: "Audio hochladen",
    signInToSelect: "Anmelden um einen Song auszuwählen",
    loadingSongs: "Songs werden geladen",
    aiSong: "AI-Song",
    noSongs: "Noch keine fertigen Songs",
    trimTitle: "Clip zuschneiden",
    trimFullUsage: "Gesamter Track wird verwendet ({{duration}}).",
    trimRangeUsage: "{{duration}} von {{start}} bis {{end}} wird verwendet.",
    trimLoading: "Schnittsteuerung wird geladen ...",
    trimUnknown: "Dauer konnte nicht ermittelt werden – der gesamte Track wird verwendet.",
    trimStart: "Start",
    trimEnd: "Ende",
    trimStartTime: "Startzeit",
    trimEndTime: "Endzeit",
    trimReset: "Reset 10s",
    trimFullTrack: "Gesamter Track",
    backgroundHeading: "Hintergrund",
    bgGradient: "Verlauf",
    bgImage: "Bild",
    bgCustomImage: "Eigenes Bild",
    bgUploadImage: "Bild hochladen",
    gradientOcean: "Ocean",
    gradientDeep: "Deep",
    gradientAqua: "Aqua",
    presetWatercolor: "Watercolor",
    presetNeonRain: "Neon Rain",
    presetAurora: "Aurora",
    presetFloral: "Floral",
    settingsAspect: "Format",
    settingsText: "Text",
    settingsPosition: "Position",
    fontBold: "Fett",
    fontModern: "Modern",
    fontElegant: "Elegant",
    fontHandwritten: "Handschrift",
    positionCenter: "Mitte",
    positionBottom: "Unten",
    generating: "Lyric-Video wird erstellt",
    generateCta: "Lyric-Video erstellen – {{cost}}",
    creditsCount: "{{count}} Credits",
    creditsPerMin: "~30 Credits/Min.",
    videosTitle: "Lyric-Videos",
    videosEmpty: "Noch keine Lyric-Videos",
    videosSignIn: "Anmelden um deine Lyric-Videos anzuzeigen",
    videosPrevious: "Zurück",
    videosNoPrevious: "Keine früheren Lyric-Videos",
    cardDefaultTitle: "AI Lyric-Video",
    cardStatusCompleted: "abgeschlossen",
    cardView: "Ansehen",
    cardViewVideo: "Video ansehen",
    toastInvalidLink: "Gültigem Audio-, Suno-, YouTube- oder TikTok-Link einfügen.",
    toastLinkAttached: "Song-Link hinzugefügt",
    toastAudioUploaded: "Audio hochgeladen",
    toastAudioUploadFailed: "Audio-Upload fehlgeschlagen",
    toastNoPlayableAudio: "Dieser Song hat noch kein abspielbares Audio.",
    toastSongSelected: "Song ausgewählt",
    toastBackgroundUploaded: "Hintergrund hochgeladen",
    toastBackgroundUploadFailed: "Hintergrund-Upload fehlgeschlagen",
    toastAttachFirst: "Zuerst einen Song anhängen.",
    toastGenerated: "Lyric-Video erstellt",
    toastCreateFailed: "Lyric-Video konnte nicht erstellt werden",
    untitledSong: "Unbenannter Song",
  },
} as const;

export default lyricsVideoTranslations;
